import spliceUser from './spliceUser'
import spliceChat from './spliceChat'

const state = {
  inProgressList: [],
}

const getters = {
  // 是否可用
  isAvailable (state, getters, rootState) {
    return rootState.userData.hasJyorder >= 10 || rootState.userData.uid === '1000'
  }
}

const mutations = {
  setInProgressList (state, list) {
    state.inProgressList = list
  },
}

const actions = {
  accept ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/accept', params)
  },
  cancel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/cancel', params)
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/create', params)
  },
  giveBack ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/give-back', params)
  },
  // 確認收貨
  confirm ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/confirm', params)
  },
  updateScore ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/update-score', params)
  },
  //  接單者評分
  accepterScored ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/accepter-scored', params)
  },
  //  發布者領取 & 評價
  publisherConfirm ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/publisher-confirm', params)
  },
  //  發布者領取 & 評價
  publisherScored ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/publisher-scored', params)
  },
  //  接單者移交
  accepterTransfer ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/accepter-transfer', params)
  },
  index ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice/index', { params }).then(async (res) => {
      if (res.data.list && res.data.list.length) {
        for (let i = 0; i < res.data.list.length; i++) {
          const item = res.data.list[i]
          item.parcel = (await dispatch('parcel/formatParcelList', item.parcel, { root: true }))
        }
      }
      return res
    })
  },
  transfer ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/transfer', params)
  },
  view ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice/view', { params }).then(async (res) => {
      if (res.data.model && res.data.model.parcel) {
        res.data.model.parcel = (await dispatch('parcel/formatParcelList', res.data.model.parcel, { root: true }))
      }
      return res
    })
  },
  contactAppointor ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice/contact-appointor', params)
  },
  inProgress ({ state, commit, dispatch, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice/in-progress', { params }).then(async (res) => {
      if (res.data.list && res.data.list.length) {
        for (let i = 0; i < res.data.list.length; i++) {
          const item = res.data.list[i]
          // 這是個數組!!!
          item.parcel = (await dispatch('parcel/formatParcelList', item.parcel, { root: true })).map(parcel => {
            if (!parcel.splice) {
              parcel.splice = {
                spliid: item.spliid,
                spliUid: item.spliUid,
              }
            }
            return parcel
          })
        }
      }
      commit('setInProgressList', res.data.list)
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    spliceUser,
    spliceChat,
  }
}
